'use strict';

var COMMONFUNCTIONS = COMMONFUNCTIONS || {};

//               //
//  FUNCTIONS    //
//               //
    COMMONFUNCTIONS.transitions = {
        scrollToTop: function(){
            window.scrollTo(0, 0);
        }
    };


    COMMONFUNCTIONS.forms = {
        reset: function(formId){
            document.getElementById(formId).reset();
        }
    };
